// @greenlight-spec: 12-azure-installation.md
// @greenlight-spec: 28-it-dashboard-ui.md
import { Outlet } from 'react-router-dom';

import { Logo } from '@/components/greenlight/Logo';

export function InstallLayout() {
  return (
    // globals.css locks html/body/#root to overflow:hidden (AppShell owns its
    // own scrolling), so the document can never scroll — this full-width root
    // must be the scroll container. Full-width matters: scoping the scroll to
    // the centered column puts the scrollbar at the column edge and makes the
    // wheel dead everywhere else on the screen.
    <div
      data-testid="install-layout"
      className="h-full overflow-y-auto bg-background flex flex-col items-center"
    >
      <header className="w-full max-w-[820px] shrink-0 px-4 py-6 flex items-center gap-3">
        <Logo className="h-5 text-foreground" />
        <span className="font-mono text-[11px] uppercase tracking-[0.06em] text-muted-foreground">
          Install
        </span>
      </header>
      <main className="w-full max-w-[820px] px-4 pb-12">
        <Outlet />
      </main>
    </div>
  );
}
